export const outlinePanelStyles = {
  borderLeft: ({ palette }) => `3px solid ${palette.divider}`,
  backgroundColor: ({ palette }) => palette.background.default,
  maxHeight: '430px',
  overflowY: 'auto',
  padding: '6px 4px',
};

export const outlineTitleStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 8px 8px',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: ({ palette }) => palette.text.secondary,
};

export const getRowStyles = ({
  depth,
  hasPosition,
  isComparison,
  isActive,
  hasProblem,
  parentBadge,
}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '7px',
  paddingLeft: `${8 + depth * 16}px`,
  paddingTop: '4px',
  paddingBottom: '4px',
  paddingRight: '8px',
  borderRadius: '7px',
  cursor: hasPosition ? 'pointer' : 'default',
  opacity: hasPosition ? 1 : 0.5,
  ...(isComparison || parentBadge ? getRailDecoration(parentBadge) : {}),
  ...(hasProblem
    ? {
        backgroundColor: ({ palette }) => palette.error.light,
      }
    : {}),
  ...(isActive && !hasProblem
    ? {
        backgroundColor: ({ palette }) => palette.action.hover,
      }
    : {}),
  '&:hover': hasPosition
    ? {
        backgroundColor: ({ palette }) => (hasProblem ? palette.error.light : palette.action.hover),
      }
    : {},
});

const BADGE_PALETTE = {
  ALL: ({ palette }) => ({ bg: palette.primary.light, fg: palette.primary.main }),
  ANY: ({ palette }) => ({ bg: palette.warning.light, fg: palette.warning.dark }),
  WHERE: ({ palette }) => ({ bg: palette.success.light, fg: palette.success.dark }),
  CALC: ({ palette }) => ({ bg: palette.secondary.light, fg: palette.secondary.dark }),
  IF: ({ palette }) => ({ bg: palette.warning.light, fg: palette.warning.dark }),
  ERR: ({ palette }) => ({ bg: palette.error.main, fg: palette.common.white }),
};

export const getBadgeStyles = badge => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '5px',
  padding: '1px 5px',
  flexShrink: 0,
  marginTop: '1px',
  fontWeight: 700,
  backgroundColor: theme => (BADGE_PALETTE[badge]?.(theme) ?? BADGE_PALETTE.ERR(theme)).bg,
  color: theme => (BADGE_PALETTE[badge]?.(theme) ?? BADGE_PALETTE.ERR(theme)).fg,
});

export const getRowTextStyles = hasProblem => ({
  minWidth: 0,
  color: ({ palette }) => (hasProblem ? palette.error.main : palette.text.primary),
});

// Indent rail color by the enclosing group's logic kind; ANY uses a dashed rail
// to echo the OR mockup. Falls back to the neutral divider for ungrouped rows.
const RAIL_PALETTE = {
  ALL: { color: ({ palette }) => palette.primary.main, style: 'solid' },
  ANY: { color: ({ palette }) => palette.warning.main, style: 'dashed' },
  WHERE: { color: ({ palette }) => palette.success.main, style: 'solid' },
  IF: { color: ({ palette }) => palette.info.dark, style: 'solid' },
  ERR: { color: ({ palette }) => palette.error.main, style: 'solid' },
};

const getRailDecoration = parentBadge => {
  const rail = RAIL_PALETTE[parentBadge];

  if (!rail) {
    return {
      borderLeft: ({ palette }) => `2px solid ${palette.divider}`,
      marginLeft: '8px',
    };
  }

  return {
    borderLeftWidth: '2px',
    borderLeftStyle: rail.style,
    borderLeftColor: rail.color,
    marginLeft: '8px',
  };
};

export const outlineChevronButtonStyles = {
  flexShrink: 0,
  padding: '0px',
  marginTop: '1px',
  color: ({ palette }) => palette.text.disabled,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  lineHeight: 1,
};
